/**
 * import dependencies
 */
import ElementHelpers from '../../original/js/libraries/element-helpers';

import { TabBar as OrbitBase } from '../../original/js/components/tab-bar';

/**
 * Declare global vars
 */
const attributeBase = 'data-rs-tab-bar';

export class TabBar extends OrbitBase  {
  constructor(element) {
    super(element);

    this.contentItems = element.parentElement.parentElement.parentElement.querySelectorAll(`[${this.attributes.tabContentItem}]`);
  }
  /**
   * Declare class constants
   */
  get classes() {
    return {
      fadeElement: 'fade-element',
      fadeElementRight: 'fade-element--right',
      fadeElementLeft: 'fade-element--left',
      icon: 'icon',
      iconLeft: 'icon__left',
      iconRight: 'icon__right',
      hide: 'hide',
      active: 'active'
    }
  }

  /**
   * Declare attribute constants
   */
  get attributes() {
    return {
      item: `${attributeBase}-item`,
      iconLeft: `${attributeBase}-icon-left`,
      iconRight: `${attributeBase}-icon-right`,
      fadeElementLeft: `${attributeBase}-fade-element-left`,
      fadeElementRight: `${attributeBase}-fade-element-right`,
      tabContent: `${attributeBase}-content`,
      tabContentItem: `${attributeBase}-content-item`,
      animationType: `${attributeBase}-animation-type`
    }
  }

  /**
   * insert fade elements at start and end of list items
   */
  setFadeElements() {
    // IE conflict with foreach NodeList.
    [].forEach.call(this.items, (item, index, array) => {
      if (index === 1) {
        item.insertAdjacentHTML('beforebegin', this.fadeLeft);
      }
      if (index === array.length - 1) {
        item.insertAdjacentHTML('afterend', this.fadeRight);
      }
    });
  }

  /*
   * Find corresponding content container and make it active, hide all others.
   */
  toggleActiveContent(element) {
    if (this.contentItems.length) {
      const id = element.getAttribute(this.attributes.item);
      this.contentItems.forEach(item => {
        item.classList.remove(this.classes.active);

        if (id === item.getAttribute(this.attributes.tabContentItem)) {
          item.classList.add(this.classes.active);
          // Fix carousel wrong resing after tab change.
          this.handleCarousels(item)
        }
      });
    }
  }

  /**
   * add event listeners to all Tab-bar elements
   */
  addEventListeners() {
    this.iconLeft = ElementHelpers.getElementByAttributeWithinElement(this.element, this.attributes.iconLeft);
    this.iconRight = ElementHelpers.getElementByAttributeWithinElement(this.element, this.attributes.iconRight);

    // scroll left on click
    this.iconLeft.addEventListener('click', () => {
      this.element.scrollBy({ left: -(this.element.clientWidth / 2), behavior: 'smooth' });
    });
    // scroll right on click
    this.iconRight.addEventListener('click', () => {
      this.element.scrollBy({ left: this.element.clientWidth / 2, behavior: 'smooth' });
    });
    //reset position fadeElement/chevron on scroll
    this.element.addEventListener('scroll', () => {
      this.toggleFadeElements();
    });
    //reset position fadeElement/chevron on resize
    window.addEventListener('resize', () => {
      this.toggleFadeElements();
      this.scrollToActive();
    });
    //loop items and add click event to call setActiveClass function
    // IE conflict with foreach NodeList.
    [].forEach.call(this.items, item => {
      item.addEventListener('click', event => {
        event.preventDefault();
        this.setActiveClass(event);
        this.toggleActiveContent(item);
      });
    });
  }

  /**
   * Handle carousels inside content.
   */
  handleCarousels(currentTarget) {
    // Check if there is carousel inside the current content.
    const carousels = currentTarget.querySelectorAll('[data-rs-carousel]');

    if (carousels.length > 0) {
      // The resize event will trigger the carousel to resize and it will fix itself.
      carousels.forEach(item => item.slick && item.slick.refresh());
    }
  }

  /**
   * Set or remove active state on list item
   */
  setActiveClass(event) {
    // IE conflict with foreach NodeList.
    [].forEach.call(this.items, item => {
      item.classList.remove(this.classes.active);
    });
    event.currentTarget.classList.add(this.classes.active);
    this.scrollToActive();
  }

  /**
   * on init and resize, scroll to active item
   * This Override is to add an "if" statement if active element is set.
   */
  scrollToActive() {
    this.activeElement = ElementHelpers.getElementByClassWithinElement(this.element, this.classes.active);
    const animationType = this.element.hasAttribute(this.attributes.animationType) ? this.element.getAttribute(this.attributes.animationType) : 'smooth';

    if (!!this.activeElement) {
      const rectTabBar = this.element.getBoundingClientRect();
      const rectActiveTab = this.activeElement.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const inScreenSize = viewportWidth - (rectTabBar.left * 2);
      if ((rectActiveTab.left + (this.activeElement.clientWidth) > inScreenSize)) {
        this.element.scrollBy({behavior: animationType, left: (rectActiveTab.left - (rectTabBar.left * 2))});
      } else if (rectActiveTab.left < (this.activeElement.clientWidth + 50)) {
        this.element.scrollBy({behavior: animationType, left: (rectActiveTab.left - (inScreenSize / 2))});
      }
    }
  }
}
